import area from '@turf/area';
import distance from '@turf/distance';
import bbox from '@turf/bbox';
import bboxPolygon from '@turf/bbox-polygon';
import center from '@turf/center';
import {RUNTIME_MAP_FEATURES, MARKER_STATES} from './mapboxMapDashboardConstants';
// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl from '!mapbox-gl'; // https://docs.mapbox.com/mapbox-gl-js/guides/install/#excluding-mapbox-gl-js-explicitly-from-transpilation
const OPTIMIZE_GEOMETRIES_VIA_TOLERANCE = true;
const LOW_DENSITY_MONITORS_MAGIC_SCALE_FACTOR_NUMERATOR = 1.38888888888; // rough notes: 1/1.38888888888 is 0.72
const LAYER_IDS = {
    GEOFENCES: {
        POLYGONS: 'klashwerks_all_geofences_layer',
        LABELS: 'klashwerks_all_geofence_labels_layer',
        SELECTED_OUTLINE: 'klashwerks_selected_geofence_outline_layer'
    },
};
export const GEOFENCE_LAYER_IDS = Object.values(LAYER_IDS.GEOFENCES);

export default class MapboxHelper {

    // camera animation helpers
    static easingFunctions = { // https://gist.github.com/gre/1650294
        // no easing, no acceleration
        linear: function (t) { return t; },
        // accelerating from zero velocity
        easeInQuad: function (t) { return t * t; },
        // decelerating to zero velocity
        easeOutQuad: function (t) { return t * (2 - t); },
        // acceleration until halfway, then deceleration
        easeInOutQuad: function (t) { return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t; },
        // accelerating from zero velocity
        easeInCubic: function (t) { return t * t * t; },
        // decelerating to zero velocity
        easeOutCubic: function (t) { return (--t) * t * t + 1; },
        // acceleration until halfway, then deceleration
        easeInOutCubic: function (t) { return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1; },
        // accelerating from zero velocity
        easeInQuart: function (t) { return t * t * t * t; },
        // decelerating to zero velocity
        easeOutQuart: function (t) { return 1 - (--t) * t * t * t; },
        // acceleration until halfway, then deceleration
        easeInOutQuart: function (t) { return t < .5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t; },
        // accelerating from zero velocity
        easeInQuint: function (t) { return t * t * t * t * t; },
        // decelerating to zero velocity
        easeOutQuint: function (t) { return 1 + (--t) * t * t * t * t; },
        // acceleration until halfway, then deceleration
        easeInOutQuint: function (t) { return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t; }
    }

    static mapboxLayerIconScaleFactor () {  // returns 1 for lowest pixel density monitors (72dpi), or LESS THAN ONE for higher density monitors (e.g. basic retina returns 0.5, i.e. 1/2)
        const screenPixelDensity = window.devicePixelRatio;
        if (screenPixelDensity > 1) {
            return 1/screenPixelDensity;
        } else {
            return (LOW_DENSITY_MONITORS_MAGIC_SCALE_FACTOR_NUMERATOR/2);
            ;
        }
    }

    static getAssetMarketState(selected) {
        return selected ? MARKER_STATES.ASSET_SELECTED : MARKER_STATES.ASSET;
    }

    static getVehicleMarkerState(selected, vehicleStatus, showProblemsBadge, hasMultipleOccupants) {

        var retval;

        if(selected)
        {
            if(vehicleStatus === MARKER_STATES.PARKED)
            {
                if(showProblemsBadge && hasMultipleOccupants)
                {
                    retval =  "" + MARKER_STATES.PROBLEM_SELECTED + RUNTIME_MAP_FEATURES.VEHICLE_MARKER_MULTIPLE_OCCUPANTS_SUFFIX;
                }
                else if(showProblemsBadge)
                {
                    retval =  "" + MARKER_STATES.PROBLEM_SELECTED;
                }
                else if(hasMultipleOccupants)
                {
                    retval =  "" + MARKER_STATES.PARKED_SELECTED + RUNTIME_MAP_FEATURES.VEHICLE_MARKER_MULTIPLE_OCCUPANTS_SUFFIX;
                }
                else
                {
                    retval =  "" + MARKER_STATES.PARKED_SELECTED;
                }
            }
            else
            {
                // Must be driving
                if(showProblemsBadge && hasMultipleOccupants)
                {
                    retval =  "" + MARKER_STATES.PROBLEM_SELECTED + RUNTIME_MAP_FEATURES.VEHICLE_MARKER_MULTIPLE_OCCUPANTS_SUFFIX;
                }
                else if(showProblemsBadge)
                {
                    retval =  "" + MARKER_STATES.PROBLEM_SELECTED;
                }
                else if(hasMultipleOccupants)
                {
                    retval =  "" + MARKER_STATES.SELECTED + RUNTIME_MAP_FEATURES.VEHICLE_MARKER_MULTIPLE_OCCUPANTS_SUFFIX;
                }
                else
                {
                    retval =  "" + MARKER_STATES.SELECTED;
                }
            }
        }
        else
        {
            if(vehicleStatus === MARKER_STATES.PARKED)
            {
                if(showProblemsBadge && hasMultipleOccupants)
                {
                    retval =  "" + MARKER_STATES.PROBLEM + RUNTIME_MAP_FEATURES.VEHICLE_MARKER_MULTIPLE_OCCUPANTS_SUFFIX;
                }
                else if(showProblemsBadge)
                {
                    retval =  "" + MARKER_STATES.PROBLEM;
                }
                else if(hasMultipleOccupants)
                {
                    retval =  "" + MARKER_STATES.PARKED + RUNTIME_MAP_FEATURES.VEHICLE_MARKER_MULTIPLE_OCCUPANTS_SUFFIX;
                }
                else
                {
                    retval =  "" + MARKER_STATES.PARKED;
                }
            }
            else
            {
                // Must be driving
                if(showProblemsBadge && hasMultipleOccupants)
                {
                    retval =  "" + MARKER_STATES.PROBLEM + RUNTIME_MAP_FEATURES.VEHICLE_MARKER_MULTIPLE_OCCUPANTS_SUFFIX;
                }
                else if(showProblemsBadge)
                {
                    retval =  "" + MARKER_STATES.PROBLEM;
                }
                else if(hasMultipleOccupants)
                {
                    retval =  "" + MARKER_STATES.DRIVING + RUNTIME_MAP_FEATURES.VEHICLE_MARKER_MULTIPLE_OCCUPANTS_SUFFIX;
                }
                else
                {
                    retval =  "" + MARKER_STATES.DRIVING;
                }
            }
        }

        return retval;
    }

    static keyForVehicleMarker () {
        return RUNTIME_MAP_FEATURES.VEHICLE_MARKER_PREFIX + "-icon";
    }

    // FIXME - remove all imageAssetNameForRavenUuidAndState 
    static imageAssetNameForRavenUuid (ravenUuid) {
        return RUNTIME_MAP_FEATURES.VEHICLE_MARKER_PREFIX + "-" + ravenUuid + "-icon";
    }

    static pointTypeFeatureForRavensCurrentPosition (mostRecentLonLatArrayItemForRaven, uniqueFeatureIdForRaven, ravenUuid, vehicleStatus, showProblemsBadgeBoolean, hasMultipleOccupants = false) { // uniqueFeatureId is not the ravenUuid, but it's current index in the source array of ravens on a map (we just need a unique integer -- not string -- for the raven)

        var showProblemsBadgeBooleanInteger = 0; // false
        if (showProblemsBadgeBoolean === true) {
            showProblemsBadgeBooleanInteger = 1;
        }
        var hasMultipleOccupantsBooleanInteger = 0; // false
        if (hasMultipleOccupants === true) {
            hasMultipleOccupantsBooleanInteger = 1;
        }

        var geom = null;
        if(mostRecentLonLatArrayItemForRaven)
        {
            geom = {
                'type': 'Point',
                'coordinates': mostRecentLonLatArrayItemForRaven
            };
        }

        var feature = {
            'type': 'Feature',
            'properties': {
                'ravenUuid': ravenUuid,
                'status': vehicleStatus, // display parked or driving symbol accordingly
                'markerCategory': 'vehicle', // differentiate from events markers' categories
                'vehicleCount': 1,
                'showProblemsBadge': showProblemsBadgeBooleanInteger,
                'hasMultipleOccupants': hasMultipleOccupantsBooleanInteger
            },
            'geometry': geom,
            'id': uniqueFeatureIdForRaven
        }

        // Only one key for the runtime image asset.  Image is changed dynamically when the vehicle state changes
        feature.properties[MapboxHelper.keyForVehicleMarker()]          = MapboxHelper.imageAssetNameForRavenUuid(ravenUuid);

        return feature;
    }

    // https://www.mapbox.com/mapbox-gl-js/example/data-driven-lines/
    static lineStringTypeFeatureForAscendingSortOrderArrayOfTelematicsTimeLonLatArrays (ascendingSortOrderArrayOfTimeLonLatArrays, uniqueFeatureIdForRaven, ravenUuid, canViewVideoStream, vehicleStatus = "DEFAULT", timestamps = null) { // uniqueFeatureId is not the ravenUuid, but it's current index in the source array of ravens on a map (we just need a unique integer -- not string -- for the raven)

        var feature = {
            'type': 'Feature',
            'properties': {
                'ravenUuid': ravenUuid,
                'status': vehicleStatus,
                'lineCategory': 'default', // 'lineCategory' is currently just used to differentiate the feature from markers (markers have 'markerCategory')
                'timestamps': timestamps,
                'canViewVideoStream': canViewVideoStream // user has permission to view video stream for this raven
            },
            'geometry': null,
            'id': uniqueFeatureIdForRaven
        }

        if(ascendingSortOrderArrayOfTimeLonLatArrays && ascendingSortOrderArrayOfTimeLonLatArrays.length >= 2)
        {
            feature.geometry = {
                'type': 'LineString',
                'coordinates': []
            };

            for (var i = 0; i < ascendingSortOrderArrayOfTimeLonLatArrays.length; i++ ) {
                feature.geometry.coordinates.push([
                    ascendingSortOrderArrayOfTimeLonLatArrays[i][1], // lon
                    ascendingSortOrderArrayOfTimeLonLatArrays[i][2]  // lat
                ])
            }
        }
        return feature;
    }

    static pointTypeFeatureForRavenEvent (eventLonLatArrayItem, uniqueFeatureIdForEvent, eventCategoryNameString, ravenUuid) { // uniqueFeatureId is not the ravenUuid, but it's current index in the source array of ravens on a map (we just need a unique integer -- not string -- for the raven)
        //console.log("eventCategoryNameString: ", eventCategoryNameString);
        var feature = {
            'type': 'Feature',
            'properties': {
                'ravenUuid': ravenUuid,
                'markerCategory': eventCategoryNameString, // corresponds to event categories (alert, parked, speeding, etc)
                'vehicleCount': 0 // events are not vehicles (count them as zero in clusters)
            },
            'geometry': {
                'type': 'Point',
                'coordinates': eventLonLatArrayItem
            },
            'id': uniqueFeatureIdForEvent
        }
        return feature;
    }
    static clusterMarkerSymbolLayer (sourceId, layerId) {

        const mapboxLayerIconSizeScale = MapboxHelper.mapboxLayerIconScaleFactor();

        var layer = {
            "id": layerId, 
            "type": "symbol",
            "source": sourceId,
            'filter':[
                'all',
                ['==', ['has', 'cluster'], true],
                ['==', ['has', 'showClusterInLayer'], true],
            ],
            "layout": {
                "visibility": "visible",
                "icon-image": ["string", ["get", MapboxHelper.keyForVehicleMarker()]],
                "icon-size": 1.0,
                // "icon-offset": ["literal", [0, 5]],
                "icon-anchor": "bottom",
                "icon-allow-overlap": true
            },
            "paint": {
                "icon-opacity": 1
            }
        }
        return layer;
    }

    static selectedMarkerSymbolLayerForRavensPointsTypes (sourceId, layerId) {

        const mapboxLayerIconSizeScale = MapboxHelper.mapboxLayerIconScaleFactor();

        var layer = {
            "id": layerId, // Selected layer required since you cannot use an expression at the layout properties level. "feature-state data expressions are not supported with layout properties"
            "type": "symbol",
            "source": sourceId,
            'filter':['!=', ['has', 'cluster'], true],
            "layout": {
                "visibility": "visible",
                "icon-image": ["match",
                    ["get", "markerCategory"], // MARKER_STATES.PARKED, "remote" (remote request), MARKER_STATES.PROBLEM (dtc), "speeding", "alert" (usually standard event type), "gesture" (in car request)

                    ["vehicle", "asset"],
                        ["string", ["get", MapboxHelper.keyForVehicleMarker()]], //TODO image-key-for-state-parked-selected-problem
                    // the following are the same as the klashwerks_all_ravens_vehicles_points_layer markers, but they need to be included so that both layers can share the same data source for all points
                    ["parked"],
                    "kw01_event-marker-small_parked", // set in Mapbox Studio as sprite name (corresponds to filename when uploaded in mapbox studio)

                    ["remote"],
                    "kw01_event-marker-small_remote",

                    ["problem"],
                    "kw01_event-marker-small_problem",

                    ["speeding"],
                    "kw01_event-marker-small_problem",

                    ["gesture"],
                    "kw01_event-marker-small_gesture",

                    ["geofence"],
                    "kw01_event-marker-small_geofence",

                    ["ai-event"],
                    "kw01_event-marker-small_mapbox",

                    // "fallback" (i.e, handles null or "alert"/default status)
                    "kw01_event-marker-small_alert"
                ],
                "icon-size": ["match",
                    ["get", "markerCategory"],

                    ["vehicle", "asset"],
                    mapboxLayerIconSizeScale,

                    1.0,
                ],
                "icon-offset": ["match",
                    ["get", "markerCategory"],

                    ["vehicle", "asset"],
                    ["literal", [0, 5]],

                    ["literal", [0, 0]]
                ],
                "icon-anchor": "bottom",
                "icon-allow-overlap": true // prevent icon fade-in behaviour when update data, also allow two icon markers to overlap beside eachother
            },
            "paint": {
                "icon-opacity": 1
            }
        }
        return layer;
    }

    static deselectedMarkerSymbolLayerForRavensPointsTypes (sourceId, layerId) {

        const mapboxLayerIconSizeScale = MapboxHelper.mapboxLayerIconScaleFactor();

        var layer = {
            "id": layerId,
            "type": "symbol",
            "source": sourceId,
            'filter':["!=", ['has', 'cluster'], true],
            "layout": {
                "visibility": "visible",
                "icon-image": ["match",
                    ["get", "markerCategory"], // MARKER_STATES.PARKED, "remote" (remote request), MARKER_STATES.PROBLEM (dtc), "speeding", "alert" (usually standard event type), "gesture" (in car request)

                    ["vehicle", "asset"],
                        ["string", ["get", MapboxHelper.keyForVehicleMarker()]],
                    ["parked"],
                    "kw01_event-marker-small_parked", // set in Mapbox Studio as sprite name (corresponds to filename when uploaded in mapbox studio)

                    ["remote"],
                    "kw01_event-marker-small_remote",

                    ["problem"],
                    "kw01_event-marker-small_problem",

                    ["speeding"],
                    "kw01_event-marker-small_problem",

                    ["gesture"],
                    "kw01_event-marker-small_gesture",

                    ["geofence"],
                    "kw01_event-marker-small_geofence",

                    ["ai-event"],
                    "kw01_event-marker-small_mapbox",

                    // "fallback" (i.e, handles null or "alert"/default status)
                    "kw01_event-marker-small_alert"
                ],
                "icon-size": ["match",
                    ["get", "markerCategory"],

                    ["vehicle", 'asset'],
                    mapboxLayerIconSizeScale,

                    1.0,
                ],
                "icon-offset": ["match",
                    ["get", "markerCategory"],

                    ["vehicle", "asset"],
                    ["literal", [0, 5]], // https://github.com/mapbox/mapbox-gl-js/issues/6155

                    ["literal", [0, 0]]
                ],
                "icon-anchor": "bottom",
                "icon-allow-overlap": true, // prevent icon fade-in behaviour when update data, also allow two icon markers to overlap beside eachother

                /* https://github.com/mapbox/mapbox-gl-js/issues/4064 makes it a waste of time trying to add vehicle and event text labels to the same layer
                mollymerp commented on Feb 1, 2017
                " ... this might be a technical limitation of our current implementation
                  of symbol layers – we draw all icons in a layer, and then all text on
                  top of that, so there is no maintained relationship between a single
                  icon and its text label in the render order. I agree this would be a
                  great enhancement, but it would require a significant refactor."

                To avoid this, I think we would have to move to using Mapbox Markers

                //"symbol-placement": "point", //"point" (default), "line", "line-center"
                //"text-pitch-alignment": "auto", // Orientation of text when map is pitched. "map" (aligned to the plane of the map), "viewport", "auto" (default, means match "text-rotation-alignment" value
                //"text-rotation-alignment": "auto", // The rotation behavior of the individual glyphs forming the text. "map", "viewport", "auto" (default, means "viewport" if "symbol-placement" is "point")
                "text-field": "{markerCategory}",
                "text-font": ["Open Sans Regular","Arial Unicode MS Regular"], //(default)
                "text-size": 10,
                "text-max-width": 10, // The maximum line width for WORD wrapping (not "text"/character wrapping). Units in ems. Defaults to 10
                "text-line-height": 0.8, // Text leading value for multi-line text. Units in ems. Defaults to 1.2
                "text-letter-spacing": 0, // Units in ems. Defaults to 0.
                "text-justify": "left", // "left", "center" (default), "right"
                "text-anchor": "top", // "center" (default), "left", "right", "top", "bottom", "top-left",  "top-right", "bottom-left", "bottom-right"
                "text-padding": 0,// Size of the additional area around the text bounding box used for detecting symbol collisions. Units in pixels. Defaults to 2
                "text-transform": "none", // "none" (default), "uppercase", "lowercase"
                "text-offset": [0, 0], // Positive values indicate right and down, while negative values indicate left and up.
                "text-allow-overlap": true, // CRITICAL, if false the text label will not show over the icon image
                "text-ignore-placement": true, // If true (default is false), other symbols can be visible even if they collide with the text.
                "text-optional": true // If true (default is false), icons will display without their corresponding text when the text collides with other symbols and the icon does not. */
            },
            "paint": {
                "icon-opacity": 1
            }
        };
        return layer;
    }

    static setGeofenceLayersVisible(mapboxMap, visible) {
        const layerIds = Object.keys(LAYER_IDS.GEOFENCES).map(k => LAYER_IDS.GEOFENCES[k]);
        if (!mapboxMap.getLayer(layerIds[0])) return false;
        layerIds.forEach(id => {
            mapboxMap.setLayoutProperty(id, 'visibility', visible ? 'visible' : 'none');
        });
        return true;
    }

    static addAssetTrackerImagesToMap (mapboxMap, uuid, name, markerState, darkThemeSelected) {

        const mapboxLayerIconSizeScale = MapboxHelper.mapboxLayerIconScaleFactor();

        // generate CSS values for scale
        const borderThickness = (1/mapboxLayerIconSizeScale) * LOW_DENSITY_MONITORS_MAGIC_SCALE_FACTOR_NUMERATOR; // originally 1.3333, but using 1.38888... since it appears to be nicer on low density monitors
        const paddingHorizontal = (1/mapboxLayerIconSizeScale) * 6;
        const paddingVertical = (1/mapboxLayerIconSizeScale) * 4;
        const borderRadius = (1/mapboxLayerIconSizeScale) * 8;
        const fontSizePixels = (1/mapboxLayerIconSizeScale) * (LOW_DENSITY_MONITORS_MAGIC_SCALE_FACTOR_NUMERATOR*10); // originally 13, but using 13.8888... since it appears to be nicer on low density monitors
        const lineHeightFontSize = Math.round((1/mapboxLayerIconSizeScale) * (LOW_DENSITY_MONITORS_MAGIC_SCALE_FACTOR_NUMERATOR*10)); // originall 13, but using 1.38888... since it appears to be nicer on low density monitors
        const driverAndVehicleStemWidth =  (1/mapboxLayerIconSizeScale) * (LOW_DENSITY_MONITORS_MAGIC_SCALE_FACTOR_NUMERATOR * LOW_DENSITY_MONITORS_MAGIC_SCALE_FACTOR_NUMERATOR); // originally 1.5, but using ~1.92 since if appears to be nicer on low density monitors
        const driverAndVehicleStemHeight = (1/mapboxLayerIconSizeScale) * 27;
        const driverAndVehicleStemEndpointRadius = (1/mapboxLayerIconSizeScale) * (LOW_DENSITY_MONITORS_MAGIC_SCALE_FACTOR_NUMERATOR * 4.5); // originally 5.64, but using ~5.5556 since it appears to be nicer on low density monitors
        const driverAndVehicleStemEndpointBorderRadius = driverAndVehicleStemEndpointRadius/2;
        var driverAndVehicleWrapperHeight = lineHeightFontSize;
        const canvasWidth = (1/mapboxLayerIconSizeScale) * 160; // 160 derived from the mockups
        const canvasHeight = driverAndVehicleWrapperHeight*1 + paddingVertical*2 + borderThickness*2 + driverAndVehicleStemHeight + (driverAndVehicleStemEndpointRadius);

        const mapboxImageID = MapboxHelper.imageAssetNameForRavenUuid(uuid, markerState);
        const markerImg = document.createElement('img');
        markerImg.addEventListener('load', () => onImgLoad(markerImg, mapboxImageID));
        // generate the raster image from html
        markerImg.src = createSrcUrl(name, markerState);

        function onImgLoad (img, mapboxImageID) {

            if (!mapboxImageID) {
                console.error("MapboxHelper.addAssetTrackerImagesToMap.onImgLoad: no mapboxImageID");
                return;
            }

            if(mapboxMap.hasImage(mapboxImageID))
            {
                mapboxMap.removeImage(mapboxImageID);
                mapboxMap.addImage(mapboxImageID, img);
            }
            else
            {
                mapboxMap.addImage(mapboxImageID, img);
            }
        }

        function createSrcUrl(name, markerState) {

            var labelBackgroundColor;
            var labelTextColor;
            var labelBorderColor;

            // set color themes for vehicle/raven state (MARKER_STATES.PARKED, MARKER_STATES.SELECTED, MARKER_STATES.PROBLEM);
            switch (markerState) {
                case MARKER_STATES.ASSET:
                    labelBackgroundColor = "#62A6DE";
                    labelTextColor = "#FFFFFF";
                    labelBorderColor = darkThemeSelected ? "#62A6DE" : "#62A6DE";
                    break;
                case MARKER_STATES.ASSET_SELECTED:
                    labelBackgroundColor = "#0765B3";
                    labelTextColor = "#FFFFFF";
                    labelBorderColor = darkThemeSelected ? "#0765B3" : "#0765B3";
                    break;
                default:
                    // default colors (grayscale):
                    labelBackgroundColor = darkThemeSelected ? "#000000" : "#474747";
                    labelTextColor = darkThemeSelected ? "#EEEEEE" : "#FFFFFF";
                    labelBorderColor = darkThemeSelected ? "#DDDDDD" : "#222222";
                    break;
            }

            return 'data:image/svg+xml,' +
                encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" ' +
                    'width="' + canvasWidth + '" ' +
                    'height="' + canvasHeight + '">' +
                    '<foreignObject ' +
                    'width="100%" ' +
                    'height="100%">' +
                    '<div xmlns="http://www.w3.org/1999/xhtml" class="canvasWrapper">' +
                    '<style> ' +
                    'div.canvasWrapper { ' +
                    'width: ' + canvasWidth + 'px; ' +
                    'height: ' + canvasHeight + 'px; ' +
                    'margin: 0px; ' +
                    'padding: 0px; ' +
                    '} ' +
                    'div.driverAndVehicleWrapper { ' +
                    'width: auto;' +
                    'height: ' + driverAndVehicleWrapperHeight + 'px; ' +
                    'font-family: "Helvetica Neue", Helvetica, Arial, "sans-serif"; ' +
                    'font-weight: 400; ' +
                    'font-size: ' + fontSizePixels + 'px; ' +
                    'color: ' + labelTextColor + '; ' +
                    'line-height: ' + lineHeightFontSize + 'px; ' +
                    'background-color: ' + labelBackgroundColor + '; ' +
                    'border: ' + borderThickness + 'px solid ' + labelBorderColor + '; ' +
                    'border-radius: ' + borderRadius + 'px; ' +
                    'padding: ' + paddingVertical + 'px ' +
                    paddingHorizontal + 'px ' +
                    paddingVertical + 'px ' +
                    paddingHorizontal + 'px; ' +
                    'margin: 0px; ' +
                    'text-align: center; ' +
                    '} ' +
                    'div.driverAndVehicleWrapper div.vehicleName { ' + /* RAV-1760 quick fix */
                    'white-space: nowrap; ' +
                    'overflow: hidden; ' +
                    'text-overflow: ellipsis; ' +
                    '} ' +
                    'div.driverAndVehicleWrapper div.driverName { ' + /* RAV-1716 quick fix */
                    'white-space: nowrap; ' +
                    'overflow: hidden; ' +
                    'text-overflow: ellipsis; ' +
                    '} ' +
                    'div.driverAndVehicleStem { ' +
                    'width: ' + driverAndVehicleStemWidth + 'px; ' +
                    'height: '+ driverAndVehicleStemHeight + 'px; ' +
                    'margin: 0px auto 0px auto; ' +
                    'padding: 0px; ' +
                    'background-color: ' + labelBorderColor + '; ' +
                    '} ' +
                    'div.driverAndVehicleStemEndpoint { ' +
                    'width: '+ driverAndVehicleStemEndpointRadius + 'px; ' +
                    'height: '+ driverAndVehicleStemEndpointRadius + 'px; ' +
                    'margin: 0px auto 0px auto; ' +
                    'border: none; ' +
                    'border-radius: ' + driverAndVehicleStemEndpointBorderRadius + 'px; ' +
                    'padding: 0px; ' +
                    'background-color: ' + labelBorderColor + '; ' +
                    '} ' +
                    '</style> ' +
                    '<div class="driverAndVehicleWrapper">' +
                    '<div class="name">' + name + '</div>' +
                    '</div>' +
                    '<div class="driverAndVehicleStem"></div>' +
                    '<div class="driverAndVehicleStemEndpoint"></div>' +
                    '</div> ' +
                    '</foreignObject> ' +
                    '</svg>'
                );
        }
    }

    static addClusterImagesToMap (mapboxMap, uuid, marker) {
        const mapboxImageID = MapboxHelper.imageAssetNameForRavenUuid(uuid);
        const markerImg = document.createElement('img');
        markerImg.addEventListener('load', () => onImgLoad(markerImg, mapboxImageID));
        // generate the raster image from html
        markerImg.src = createSrcUrl(marker);

        function onImgLoad (img, mapboxImageID) {

            if (!mapboxImageID) {
                console.error("MapboxHelper.addClusterImagesToMap.onImgLoad: no mapboxImageID");
                return;
            }

            if(mapboxMap.hasImage(mapboxImageID))
            {
                mapboxMap.removeImage(mapboxImageID);
                mapboxMap.addImage(mapboxImageID, img);
            }
            else
            {
                mapboxMap.addImage(mapboxImageID, img);
            }
        }

        function createSrcUrl(marker) {
            return 'data:image/svg+xml,' + encodeURIComponent(marker);
        }
    }


    static addVehicleMarkersAssetsForRaven (mapboxMap, ravenUUID, vehicleName, driverName, vehicleMarkerState, darkThemeSelected, update) {

        const mapboxLayerIconSizeScale = MapboxHelper.mapboxLayerIconScaleFactor();

        // generate CSS values for scale
        const borderThickness = (1/mapboxLayerIconSizeScale) * LOW_DENSITY_MONITORS_MAGIC_SCALE_FACTOR_NUMERATOR; // originally 1.3333, but using 1.38888... since it appears to be nicer on low density monitors
        const paddingHorizontal = (1/mapboxLayerIconSizeScale) * 6;
        const paddingVertical = (1/mapboxLayerIconSizeScale) * 1;
        const borderRadius = (1/mapboxLayerIconSizeScale) * 8;
        const fontSizePixels = (1/mapboxLayerIconSizeScale) * (LOW_DENSITY_MONITORS_MAGIC_SCALE_FACTOR_NUMERATOR*10); // originally 13, but using 13.8888... since it appears to be nicer on low density monitors
        const lineHeightFontSize = Math.round((1/mapboxLayerIconSizeScale) * (LOW_DENSITY_MONITORS_MAGIC_SCALE_FACTOR_NUMERATOR*10)); // originall 13, but using 1.38888... since it appears to be nicer on low density monitors
        const driverAndVehicleStemWidth =  (1/mapboxLayerIconSizeScale) * (LOW_DENSITY_MONITORS_MAGIC_SCALE_FACTOR_NUMERATOR * LOW_DENSITY_MONITORS_MAGIC_SCALE_FACTOR_NUMERATOR); // originally 1.5, but using ~1.92 since if appears to be nicer on low density monitors
        const driverAndVehicleStemHeight = (1/mapboxLayerIconSizeScale) * 27;
        const driverAndVehicleStemEndpointRadius = (1/mapboxLayerIconSizeScale) * (LOW_DENSITY_MONITORS_MAGIC_SCALE_FACTOR_NUMERATOR * 4.5); // originally 5.64, but using ~5.5556 since it appears to be nicer on low density monitors
        const driverAndVehicleStemEndpointBorderRadius = driverAndVehicleStemEndpointRadius/2;
        var driverAndVehicleWrapperHeight = lineHeightFontSize;
        var multipleOccupantsIconWrapperWidth = (1/mapboxLayerIconSizeScale) * 22;
        if (driverName) {
            if (driverName.trim().length > 0) {
                multipleOccupantsIconWrapperWidth = multipleOccupantsIconWrapperWidth*1.5;
                driverAndVehicleWrapperHeight = driverAndVehicleWrapperHeight * 2;
            }
        }
        const canvasWidth = (1/mapboxLayerIconSizeScale) * 160; // 160 derived from the mockups
        const canvasHeight = driverAndVehicleWrapperHeight*1 + paddingVertical*2 + borderThickness*2 + driverAndVehicleStemHeight + (driverAndVehicleStemEndpointRadius);

        const canvasWidthWithIcon = canvasWidth + multipleOccupantsIconWrapperWidth + paddingHorizontal;
        const driverVehicleAndIconWrapperWidth = canvasWidthWithIcon - paddingHorizontal*2 - borderThickness*2;


        let vehicleMarkerAsset = document.createElement('img');
        // add mapboxImageID as a target attribute (to escape for-loop scope)
        vehicleMarkerAsset.mapboxImageID = MapboxHelper.imageAssetNameForRavenUuid(ravenUUID);
        vehicleMarkerAsset.addEventListener('load', (e) => { onVehicleMarkerAssetLoaded(e, vehicleMarkerAsset) });

        // generate the image rasterized with driver and vehicle name
        vehicleMarkerAsset.src = vehicleMarkerAssetFor(vehicleName, driverName, vehicleMarkerState);


        function onVehicleMarkerAssetLoaded (e, scopedVehicleMarkerAsset) {

            var mapboxImageID = e.target.mapboxImageID;
            if (!mapboxImageID) {
                console.log("MapboxHelper addVehicleMarkersAssetsForRaven mapboxImageID onVehicleMarkerAssetLoaded event listener's target is missing the mapboxImageID attribute");
            }

            if(mapboxMap.hasImage(mapboxImageID))
            {
                mapboxMap.removeImage(mapboxImageID);
                mapboxMap.addImage(mapboxImageID, scopedVehicleMarkerAsset);
            }
            else
            {
                mapboxMap.addImage(mapboxImageID, scopedVehicleMarkerAsset);
            }
        }

        function vehicleMarkerAssetFor (vehicleMarkerVehicleName, vehicleMarkerDriverName, vehicleMarkerState) {

            var vehicleLabelBackgroundColor;
            var vehicleLabelTextColor;
            var vehicleLabelBorderColor;

            // use a base64Encoded image asset (a workaround to load asset synchronously/serially)
            const base64EncodedMultipleOccupantsIconBlack = "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMTYiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI0IDE2IiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBmaWxsPSJub25lIiBkPSJNMCwwaDI0djE2SDBWMHoiLz48cGF0aCBkPSJNMTYsN2MxLjcsMCwzLTEuMywzLTNzLTEuMy0zLTMtM3MtMywxLjMtMywzUzE0LjMsNywxNiw3eiBNOCw3YzEuNywwLDMtMS4zLDMtM1M5LjcsMSw4LDFTNSwyLjMsNSw0UzYuMyw3LDgsN3ogTTgsOWMtMi4zLDAtNywxLjItNywzLjVWMTVoMTR2LTIuNUMxNSwxMC4yLDEwLjMsOSw4LDl6IE0xNiw5Yy0wLjMsMC0wLjYsMC0xLDAuMWMxLjIsMC44LDIsMiwyLDMuNFYxNWg2di0yLjVDMjMsMTAuMiwxOC4zLDksMTYsOXoiLz48L3N2Zz4=";
            // base64EncodedMultipleOccupantsIcon was generated manually at http://b64.io/ using /public/images/multiple-occupants-icon-base64encode-black-source.svg
            const base64EncodedMultipleOccupantsIconWhite = "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMTYiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI0IDE2IiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBmaWxsPSJub25lIiBkPSJNMCwwaDI0djE2SDBWMHoiLz48cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNMTYsN2MxLjcsMCwzLTEuMywzLTNzLTEuMy0zLTMtM3MtMywxLjMtMywzUzE0LjMsNywxNiw3eiBNOCw3YzEuNywwLDMtMS4zLDMtM1M5LjcsMSw4LDFTNSwyLjMsNSw0UzYuMyw3LDgsN3ogTTgsOWMtMi4zLDAtNywxLjItNywzLjVWMTVoMTR2LTIuNUMxNSwxMC4yLDEwLjMsOSw4LDl6IE0xNiw5Yy0wLjMsMC0wLjYsMC0xLDAuMWMxLjIsMC44LDIsMiwyLDMuNFYxNWg2di0yLjVDMjMsMTAuMiwxOC4zLDksMTYsOXoiLz48L3N2Zz4=";
            // base64EncodedMultipleOccupantsIcon was generated manually at http://b64.io/ using /public/images/multiple-occupants-icon-base64encode-white-source.svg

            var base64EncodedMultipleOccupantsIcon;

            var vehicleMarkerHasMultipleOccupants = false;

            // set color themes for vehicle/raven state (MARKER_STATES.PARKED, MARKER_STATES.SELECTED, MARKER_STATES.PROBLEM);
            switch (vehicleMarkerState) {
                case MARKER_STATES.PARKED + RUNTIME_MAP_FEATURES.VEHICLE_MARKER_MULTIPLE_OCCUPANTS_SUFFIX:
                    vehicleMarkerHasMultipleOccupants = true;
                    // Fall through

                case MARKER_STATES.PARKED:
                    // parked colors (greens):
                    vehicleLabelBackgroundColor = "#5cb11b";
                    vehicleLabelTextColor = "#FFFFFF";
                    base64EncodedMultipleOccupantsIcon = base64EncodedMultipleOccupantsIconWhite;
                    vehicleLabelBorderColor = darkThemeSelected ? "#DDDDDD" : "#222222";
                    break;
                case MARKER_STATES.PARKED_SELECTED + RUNTIME_MAP_FEATURES.VEHICLE_MARKER_MULTIPLE_OCCUPANTS_SUFFIX:
                    vehicleMarkerHasMultipleOccupants = true;
                    // Fall through

                case MARKER_STATES.PARKED_SELECTED:
                    // parked colors (greens):
                    vehicleLabelBackgroundColor = "#ccecf5";// more saturated version "#b2f73a";
                    vehicleLabelTextColor = "#000000";
                    base64EncodedMultipleOccupantsIcon = base64EncodedMultipleOccupantsIconBlack;
                    vehicleLabelBorderColor = darkThemeSelected ? "#00ff00" : "#5cb11b";
                    break;
                case MARKER_STATES.IDLING + RUNTIME_MAP_FEATURES.VEHICLE_MARKER_MULTIPLE_OCCUPANTS_SUFFIX:
                    vehicleMarkerHasMultipleOccupants = true;
                    // Fall through

                case MARKER_STATES.IDLING:
                    vehicleLabelBackgroundColor = "#ffc02c";
                    vehicleLabelTextColor = "#000000";
                    base64EncodedMultipleOccupantsIcon = base64EncodedMultipleOccupantsIconBlack;
                    vehicleLabelBorderColor = darkThemeSelected ? "#DDDDDD" : "#222222";
                    break;
                case MARKER_STATES.SELECTED + RUNTIME_MAP_FEATURES.VEHICLE_MARKER_MULTIPLE_OCCUPANTS_SUFFIX:
                    vehicleMarkerHasMultipleOccupants = true;
                    // Fall through

                case MARKER_STATES.SELECTED:
                    // selected colors (branded blue):
                    vehicleLabelBackgroundColor = "#ccecf5";
                    vehicleLabelTextColor = "#000000";
                    base64EncodedMultipleOccupantsIcon = base64EncodedMultipleOccupantsIconBlack;
                    vehicleLabelBorderColor = darkThemeSelected ? "#FFFFFF" : "#000000";
                    break;
                case MARKER_STATES.PROBLEM + RUNTIME_MAP_FEATURES.VEHICLE_MARKER_MULTIPLE_OCCUPANTS_SUFFIX:
                    vehicleMarkerHasMultipleOccupants = true;
                    // Fall through

                case MARKER_STATES.PROBLEM:
                    // disconnected/dtc/problem colors (reds):
                    vehicleLabelBackgroundColor = "#FF0000";
                    vehicleLabelTextColor = "#FFFFFF";
                    base64EncodedMultipleOccupantsIcon = base64EncodedMultipleOccupantsIconWhite;
                    vehicleLabelBorderColor = darkThemeSelected ? "#DDDDDD" : "#222222";
                    break;
                case MARKER_STATES.PROBLEM_SELECTED + RUNTIME_MAP_FEATURES.VEHICLE_MARKER_MULTIPLE_OCCUPANTS_SUFFIX:
                    vehicleMarkerHasMultipleOccupants = true;
                    // Fall through

                case MARKER_STATES.PROBLEM_SELECTED:
                    // disconnected/dtc/problem colors (reds):
                    vehicleLabelBackgroundColor = "#ccecf5";
                    vehicleLabelTextColor = "#000000";
                    base64EncodedMultipleOccupantsIcon = base64EncodedMultipleOccupantsIconBlack;
                    vehicleLabelBorderColor = darkThemeSelected ? "#FF0000" : "#FF0000";
                    break;
                default:
                    // default colors (grayscale):
                    vehicleLabelBackgroundColor = darkThemeSelected ? "#000000" : "#474747";
                    vehicleLabelTextColor = darkThemeSelected ? "#EEEEEE" : "#FFFFFF";
                    base64EncodedMultipleOccupantsIcon = base64EncodedMultipleOccupantsIconWhite;
                    vehicleLabelBorderColor = darkThemeSelected ? "#DDDDDD" : "#222222";
                    break;
            }

            // set DOM element structure based on whether or not there are multiple occupants
            var htmlImageElementSrcString;

            if (vehicleMarkerHasMultipleOccupants === true) {

                htmlImageElementSrcString = '' +
                    'data:image/svg+xml,' +
                    encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" ' +
                        'width="' + canvasWidthWithIcon + '" ' +
                        'height="' + canvasHeight + '">' +
                            '<foreignObject ' +
                                'width="100%" ' +
                                'height="100%">' +
                                '<div xmlns="http://www.w3.org/1999/xhtml" class="canvasWrapper">' +
                                    '<style> ' +
                                        'div.canvasWrapper { ' +
                                            'width: ' + canvasWidthWithIcon + 'px; ' +
                                            'height: ' + canvasHeight + 'px; ' +
                                            'margin: 0px; ' +
                                            'padding: 0px; ' +
                                        '} ' +
                                        'div.driverVehicleAndIconWrapper { ' +
                                            'width: ' + driverVehicleAndIconWrapperWidth + 'px ;' +
                                            'height: ' + driverAndVehicleWrapperHeight + 'px; ' +
                                            'background-color: ' + vehicleLabelBackgroundColor + '; ' +
                                            'border: ' + borderThickness + 'px solid ' + vehicleLabelBorderColor + '; ' +
                                            'border-radius: ' + borderRadius + 'px; ' +
                                            'padding: ' + paddingVertical + 'px ' +
                                                        paddingHorizontal + 'px ' +
                                                        paddingVertical + 'px ' +
                                                        paddingHorizontal + 'px; ' +
                                            'margin: 0px; ' +
                                            'display: flex; ' +
                                            'flex-direction: row; ' +
                                            'align-items: center; ' +
                                            'justify-content: center; ' +
                                        '} ' +
                                        'div.driverAndVehicleStem { ' +
                                            'width: ' + driverAndVehicleStemWidth + 'px; ' +
                                            'height: '+ driverAndVehicleStemHeight + 'px; ' +
                                            'margin: 0px auto 0px auto; ' +
                                            'padding: 0px; ' +
                                            'background-color: ' + vehicleLabelBorderColor + '; ' +
                                        '} ' +
                                        'div.driverAndVehicleStemEndpoint { ' +
                                            'width: '+ driverAndVehicleStemEndpointRadius + 'px; ' +
                                            'height: '+ driverAndVehicleStemEndpointRadius + 'px; ' +
                                            'margin: 0px auto 0px auto; ' +
                                            'border: none; ' +
                                            'border-radius: ' + driverAndVehicleStemEndpointBorderRadius + 'px; ' +
                                            'padding: 0px; ' +
                                            'background-color: ' + vehicleLabelBorderColor + '; ' +
                                        '} ' +
                                        'div.driverAndVehicleWrapper { ' +
                                            'width: auto;' +
                                            'height: auto; ' +
                                            'font-family: "Helvetica Neue", Helvetica, Arial, "sans-serif"; ' +
                                            'font-weight: 400; ' +
                                            'font-size: ' + fontSizePixels + 'px; ' +
                                            'color: ' + vehicleLabelTextColor + '; ' +
                                            'line-height: ' + lineHeightFontSize + 'px; ' +
                                            'padding: 0px ' + paddingHorizontal + 'px 0px 0px; ' +
                                            'margin: 0px; ' +
                                            'text-align: center; ' +
                                        '} ' +
                                        'div.multipleOccupantsIconWrapper { ' +
                                            'width: ' + multipleOccupantsIconWrapperWidth + 'px; ' +
                                            'height: auto; ' +
                                            'margin: 0px; ' +
                                            'padding: 0px; ' +
                                        '} ' +
                                    '</style> ' +
                                    '<div class="driverVehicleAndIconWrapper">' +
                                        '<div class="driverAndVehicleWrapper">' +
                                            '<div class="vehicleName">' + vehicleMarkerVehicleName + '</div>' +
                                            (vehicleMarkerDriverName ? '<div class="driverName">' + vehicleMarkerDriverName + '</div>' : '') +
                                        '</div>' +
                                        '<div class="multipleOccupantsIconWrapper">' +
                                            '<img src="data:image/svg+xml;base64,' + base64EncodedMultipleOccupantsIcon + '" width="' + multipleOccupantsIconWrapperWidth + '" />' +
                                        '</div>' +
                                    '</div>' +
                                    '<div class="driverAndVehicleStem"></div>' +
                                    '<div class="driverAndVehicleStemEndpoint"></div>' +
                                '</div> ' +
                            '</foreignObject> ' +
                        '</svg>'
                    );
            } else { // vehicleMarkerHasMultipleOccupants == false

                htmlImageElementSrcString = '' +
                    'data:image/svg+xml,' +
                    encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" ' +
                        'width="' + canvasWidth + '" ' +
                        'height="' + canvasHeight + '">' +
                            '<foreignObject ' +
                                'width="100%" ' +
                                'height="100%">' +
                                '<div xmlns="http://www.w3.org/1999/xhtml" class="canvasWrapper">' +
                                    '<style> ' +
                                        'div.canvasWrapper { ' +
                                            'width: ' + canvasWidth + 'px; ' +
                                            'height: ' + canvasHeight + 'px; ' +
                                            'margin: 0px; ' +
                                            'padding: 0px; ' +
                                        '} ' +
                                        'div.driverAndVehicleWrapper { ' +
                                            'width: auto;' +
                                            'height: ' + driverAndVehicleWrapperHeight + 'px; ' +
                                            'font-family: "Helvetica Neue", Helvetica, Arial, "sans-serif"; ' +
                                            'font-weight: 400; ' +
                                            'font-size: ' + fontSizePixels + 'px; ' +
                                            'color: ' + vehicleLabelTextColor + '; ' +
                                            'line-height: ' + lineHeightFontSize + 'px; ' +
                                            'background-color: ' + vehicleLabelBackgroundColor + '; ' +
                                            'border: ' + borderThickness + 'px solid ' + vehicleLabelBorderColor + '; ' +
                                            'border-radius: ' + borderRadius + 'px; ' +
                                            'padding: ' + paddingVertical + 'px ' +
                                                        paddingHorizontal + 'px ' +
                                                        paddingVertical + 'px ' +
                                                        paddingHorizontal + 'px; ' +
                                            'margin: 0px; ' +
                                            'text-align: center; ' +
                                        '} ' +
                                        'div.driverAndVehicleWrapper div.vehicleName { ' + /* RAV-1760 quick fix */
                                            'white-space: nowrap; ' +
                                            'overflow: hidden; ' +
                                            'text-overflow: ellipsis; ' +
                                        '} ' +
                                        'div.driverAndVehicleWrapper div.driverName { ' + /* RAV-1716 quick fix */
                                            'white-space: nowrap; ' +
                                            'overflow: hidden; ' +
                                            'text-overflow: ellipsis; ' +
                                        '} ' +                    
                                        'div.driverAndVehicleStem { ' +
                                            'width: ' + driverAndVehicleStemWidth + 'px; ' +
                                            'height: '+ driverAndVehicleStemHeight + 'px; ' +
                                            'margin: 0px auto 0px auto; ' +
                                            'padding: 0px; ' +
                                            'background-color: ' + vehicleLabelBorderColor + '; ' +
                                        '} ' +
                                        'div.driverAndVehicleStemEndpoint { ' +
                                            'width: '+ driverAndVehicleStemEndpointRadius + 'px; ' +
                                            'height: '+ driverAndVehicleStemEndpointRadius + 'px; ' +
                                            'margin: 0px auto 0px auto; ' +
                                            'border: none; ' +
                                            'border-radius: ' + driverAndVehicleStemEndpointBorderRadius + 'px; ' +
                                            'padding: 0px; ' +
                                            'background-color: ' + vehicleLabelBorderColor + '; ' +
                                        '} ' +
                                    '</style> ' +
                                    '<div class="driverAndVehicleWrapper">' +
                                        '<div class="vehicleName">' + vehicleMarkerVehicleName + '</div>' +
                                        (vehicleMarkerDriverName ? '<div class="driverName">' + vehicleMarkerDriverName + '</div>' : '') +
                                    '</div>' +
                                    '<div class="driverAndVehicleStem"></div>' +
                                    '<div class="driverAndVehicleStemEndpoint"></div>' +
                                '</div> ' +
                            '</foreignObject> ' +
                        '</svg>'
                    );
            }
            return htmlImageElementSrcString;
        }
    }

    // https://stackoverflow.com/questions/37599561/drawing-a-circle-with-the-radius-in-miles-meters-with-mapbox-gl-js
    static createGeoJSONCircle(center, radiusInKm, properties) {

        var coords = {
            latitude: center[1],
            longitude: center[0]
        };

        var km = radiusInKm;

        var ret = [];
        var distanceX = km/(111.320*Math.cos(coords.latitude*Math.PI/180));
        var distanceY = km/110.574;

        var theta, x, y;
        for(var i=0; i<64; i++) {
            theta = (i/64)*(2*Math.PI);
            x = distanceX*Math.cos(theta);
            y = distanceY*Math.sin(theta);

            ret.push([coords.longitude+x, coords.latitude+y]);
        }
        ret.push(ret[0]);

        return {
            "type": "Feature",
            "properties": properties,
            "geometry": {
                "type": "Polygon",
                "coordinates": [ret]
            },
            id: properties.id ? properties.id : null
        }
    }

    static createGeoJSONPolygon(coordinates, properties) {

        return {
            "type": "Feature",
            "properties": properties,
            "geometry": {
                "type": "Polygon",
                "coordinates": coordinates
            },
            id: properties.id ? properties.id : null
        }
    }


    static getBoundsFromRadiusInKm(center, radiusInKm) {
        
        var coords = {
            latitude: center[1],
            longitude: center[0]
        };

        var km = radiusInKm;

        var coordinates = [];
        var distanceX = km/(111.320*Math.cos(coords.latitude*Math.PI/180));
        var distanceY = km/110.574;

        var theta, x, y;
        for(var i=0; i<64; i++) {
            theta = (i/64)*(2*Math.PI);
            x = distanceX*Math.cos(theta);
            y = distanceY*Math.sin(theta);

            coordinates.push([coords.longitude+x, coords.latitude+y]);
        }
        coordinates.push(coordinates[0]);

        //return coordinates; 
        return coordinates.reduce(function(bounds, coord) {
           return bounds.extend(coord);
           }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));
    }

    static getBoundsFromPolygon(polygon) {
        var bounds = new mapboxgl.LngLatBounds();
        polygon.forEach(function(ring) {
            ring.forEach(function(coord) {
                bounds.extend(coord);
            });
        });
        return bounds;
    }

    // function to return the center of a polygon
    static getCenterOfPolygon(polygon) {
        var bounds = new mapboxgl.LngLatBounds();
        polygon.forEach(function(ring) {
            ring.forEach(function(coord) {
                bounds.extend(coord);
            });
        });
        const centerObj = bounds.getCenter();
        return [centerObj.lng, centerObj.lat];
    }

    // returns area of polygon in square meters
    static calcPolygonArea(polygon) {
        return Math.round(area(polygon));
    }

    static checkGeofenceForOverlapingPolylines(coordinates){

        let haveOverlaps = false;
        
        // To have an overlap, Polygon should have at least 4 points
        loop1: for(let i = 3; i < coordinates.length - 1; i++){
                const currentPoint = coordinates[i];

                for(let j = i - 1; j > 0; j--){
                    const lineToCheckStartPoint = coordinates[j - 1];
                    const lineToCheckEndPoint = coordinates[j];
                    
                    const prevPoint = coordinates[i - 1];
                    const nextPoint = i + 1 > coordinates.length - 1 ? coordinates[i] : coordinates[i + 1];
                    
                    // for each point we check if the line it creates with the previous and next point intersects with any other line in the polygon

                    if(linesIntersect(currentPoint, prevPoint, lineToCheckStartPoint, lineToCheckEndPoint)){
                        if(j !== i - 1){
                            haveOverlaps = true;
                            break loop1;
                        }
                    }
                    
                    if(linesIntersect(currentPoint, nextPoint, lineToCheckStartPoint, lineToCheckEndPoint)){
                        if(i + 1 !== coordinates.length - 1 || j - 1 > 0){
                            haveOverlaps = true;
                            break loop1;            
                        }
                    }
                }
        }
        

        function linesIntersect([x1, y1], [x2, y2], [x3, y3], [x4, y4]) {
            const denom = ((y4 - y3) * (x2 - x1)) - ((x4 - x3) * (y2 - y1));
            const numeA = ((x4 - x3) * (y1 - y3)) - ((y4 - y3) * (x1 - x3));
            const numeB = ((x2 - x1) * (y1 - y3)) - ((y2 - y1) * (x1 - x3));
        
            if (denom == 0) {
              return false;
            }
        
            const uA = numeA / denom;
            const uB = numeB / denom;
        
            if (uA >= 0 && uA <= 1 && uB >= 0 && uB <= 1) {
              return true
            }
        
            return false;
          }

          return haveOverlaps;
    }

    static groupFeaturesByDistance(features, threshold) {
        const groups = [];
        const remainingFeatures = features.slice();

        const firstFeature = remainingFeatures.shift();
        groups.push([firstFeature]);

        while (remainingFeatures.length > 0) {
            const currentFeature = remainingFeatures.shift();
            let added = false;

            for (let i = 0; i < groups.length; i++) {
                const group = groups[i];
                const groupFeature = group[0];

                const featureDistanceFromGroup = distance(groupFeature, currentFeature);

                if (featureDistanceFromGroup < threshold) {
                    group.push(currentFeature);
                    added = true;
                    break;
                }
            }

            if (!added) {
                groups.push([currentFeature]);
            }
        }
        
        return groups;
    }

    static getCenterOfFeatures(features) {
        const collection = {
            type: 'FeatureCollection',
            features: features
        }
        const featuresBox = bbox(collection);
        const featuresCenter = center(bboxPolygon(featuresBox));
        return featuresCenter.geometry.coordinates;
    }

    static getDistanceAndPositionBetweenTwoFeatures(map, feature1, feature2) {
        if (!feature1 || !feature2) {
            return undefined;
        }

        // Convert coordinates to pixel positions
        const pixelPos1 = map.project(feature1.geometry.coordinates);
        const pixelPos2 = map.project(feature2.geometry.coordinates);

        let horizontally = 'aligned';
        let vertically = 'aligned';
        
        if (pixelPos1.x < pixelPos2.x) {
            horizontally = 'left';
        } else if (pixelPos1.x > pixelPos2.x) {
            horizontally = 'right';
        }

        if (pixelPos1.y > pixelPos2.y) {
            vertically = 'below';
        } else if (pixelPos1.y < pixelPos2.y) {
            vertically = 'above';
        }

        return { 
            distance: {
                horizontally: Math.abs(pixelPos1.x - pixelPos2.x),
                vertically: Math.abs(pixelPos1.y - pixelPos2.y)
            }, 
            position: 
            { horizontally, vertically } 
        };
    }

    static isClusterCoveringAFeature(status) {
        const {position, distance} = status;
        let t = false;
        if(position.vertically === 'below') {
            switch(true){
                case distance.vertically > 30 && Math.abs(distance.horizontally) <= 100:
                case distance.vertically  <= 30 && Math.abs(distance.horizontally) <= 180:
                    t = true;
            }
        }
        else{ // above or aligned
            switch(true){
                case distance.vertically >= 0 && distance.vertically < 10 && Math.abs(distance.horizontally) <= 180:
                case distance.vertically >= 10 && distance.vertically <= 54 && Math.abs(distance.horizontally) <= 100:
                    t = true;
            }
        }

        return t;
    }
}
